import React, { useState, useEffect, useRef } from "react";
import { SubmitButton } from "../../design";
//import {isApplePayJsAvailable, performApplePayPayment} from "./ApplePayJsHandler"
import { performValidation } from './ApplePayRestClient';
import currencyformatter from "../../utils/currencyformatter";
import { AmountDivideByHundred } from "../../helper";
import { API } from "../../api";

type Props = {
    chargeByApple: Function;
    subscriptionData: Object;
    link: String,
    splitUpPayload: Object,
};


const Apple = (props: Props) => {
    const { amount, chargeByApple, payment, accountName, subscriptionData, link, splitUpPayload } = props;
    const items = [];
    const [paymentInfo, setPaymentInfo] = useState({});
    const splitUpStatus = useRef(false);

    const getPaymentSplitUp = async () => {
        try {
            const { data : { entity } } = await API.post(`transaction-fee/split-up`, splitUpPayload);
            setPaymentInfo(entity);
            splitUpStatus.current = true;
        } catch (e) {
            console.error(e);
            splitUpStatus.current = false;
        }
    }

    useEffect(() => {
        getPaymentSplitUp();
    }, []);

    const existsApplePayJsApi = () => {
        return new Promise((resolve, reject) => {
            try {
                const enabled = window.ApplePaySession && window.ApplePaySession.canMakePayments();
                resolve(enabled);
            } catch (err) {
                reject(err);
            }
        })
    }

    const isApplePayJsAvailable = () => {
        try {
            return existsApplePayJsApi()
                .then(() => {
                    return window.ApplePaySession.canMakePaymentsWithActiveCard('merchant.com.swirepay.fiserv')
                })
        } catch (error) {
            console.error('Error checking Apple Pay availability:', error);
            return false;
        }
    }

    const getPaymentRequest = (currencyCode, items, label, amount) => {
        const paymentRequest = {
            currencyCode: currencyCode,
            countryCode: 'US',
            lineItems: items,
            total: {
                label: label,
                amount: amount
            },
            supportedNetworks: ['masterCard', 'visa'],
            merchantCapabilities: ['supports3DS', 'supportsCredit', 'supportsDebit'],
            requiredShippingContactFields: [
                "postalAddress",
                "name",
                "phone",
                "email"
            ],
            requiredBillingContactFields: [
                "postalAddress",
                "email",
                "name",
                "phone"
            ]
        };

        if (subscriptionData) {
            paymentRequest.recurringPaymentRequest = {
                paymentDescription: subscriptionData?.description,
                regularBilling: {
                    label: label,
                    amount: amount,
                    type: 'final',
                    paymentTiming: 'recurring',
                    recurringPaymentStartDate: subscriptionData.plan2StartDate
                        ? new Date(subscriptionData.plan2StartDate)
                        : null,

                    recurringPaymentEndDate: subscriptionData.plan2EndDate
                        ? new Date(subscriptionData.plan2EndDate)
                        : null,

                    recurringPaymentIntervalUnit: subscriptionData.plan2BillingFrequency?.toLowerCase(), // "month"
                    recurringPaymentIntervalCount: subscriptionData.plan2BillingPeriod ?? 1,
                },
                managementURL: link,
            };
        }
        return paymentRequest;
    }

    const getOnValidateMerchant = (resolve, reject, session, amount) => {
        return async (event) => {
            await performValidation(event.validationURL)
                .then((response) => {
                    console.log(response.body)
                    session.completeMerchantValidation(response.body);

                })
                .catch((err) => {
                    console.log("Validate error ", JSON.stringify(err));
                    session.abort();
                });
        }
    }

    const getOnPaymentAuthorized = (resolve, reject, session, currencyCode, amount) => {
        return (event) => {
            session.completePayment(window.ApplePaySession.STATUS_SUCCESS);
            const payment = event.payment
            const deviceData = `${payment.token.paymentData.data}&ectype=apple&ecsig=${payment.token.paymentData.signature}&eckey=${payment.token.paymentData.header.ephemeralPublicKey}&ectid=${payment.token.transactionIdentifier}&echash=&ecpublickeyhash=${payment.token.paymentData.header.publicKeyHash}`;
            console.log(payment)
            const customerName = ((payment.billingContact.givenName) ? payment.billingContact.givenName : "") + (payment.billingContact.familyName ? payment.billingContact.familyName : "")
            const customerPhone = '+1' + payment.shippingContact.phoneNumber ? '+1' + payment.shippingContact.phoneNumber : ""
            const customerEmail = payment.shippingContact.emailAddress ? payment.shippingContact.emailAddress : ""
            const countryCode = payment.billingContact.countryCode ? payment.billingContact.countryCode : ""
            const stateCode = payment.billingContact.administrativeArea ? payment.billingContact.administrativeArea : ""
            const city = payment.billingContact.locality ? payment.billingContact.locality : ""
            const street = payment.billingContact.addressLines[0] ? payment.billingContact.addressLines[0] : ""
            const postalCode = payment.billingContact.postalCode ? payment.billingContact.postalCode : ""
            const cardNetwork = payment.token.paymentMethod.network ? payment.token.paymentMethod.network : ""
            const cardType = payment.token.paymentMethod.network ? payment.token.paymentMethod.network : ""
            const cardLast4 = payment.token.paymentMethod.displayName ? payment.token.paymentMethod.displayName : ""

            const paymentData = {
                deviceData, amount, customerName, customerEmail,
                customerPhone, countryCode, stateCode, street, postalCode, city,
                cardNetwork, cardType, cardLast4
            }
            chargeByApple(paymentData);
        }
    }

    const getOnCancel = (resolve, reject, session) => {
        return (event) => {
            console.log("Session cancelled!!!");
            resolve(2);
        }
    }

    const performApplePayPayment = (currencyCode, items, label, amount) => {
        // alert(currencyCode)
        return new Promise((resolve, reject) => {
            const session = new window.ApplePaySession(subscriptionData ? 14 : 1, getPaymentRequest(currencyCode, items, label, amount));

            session.onvalidatemerchant = getOnValidateMerchant(resolve, reject, session, amount);
            session.onpaymentauthorized = getOnPaymentAuthorized(resolve, reject, session, currencyCode, amount);
            session.oncancel = getOnCancel(resolve, reject, session)

            session.begin();
        })
    }

    if (isApplePayJsAvailable()) {
        const payableAmount = splitUpStatus.current
            ? AmountDivideByHundred(paymentInfo?.totalPayable)
            : AmountDivideByHundred(payment?.totalPayable ?? payment?.total ?? payment?.amount);

        return (
            <>
                <div className="px-1 px-md-4">
                    <div class="mt-4">
                        <table class="table table-bordered mt-4">
                            <tbody>
                                {
                                    paymentInfo?.amount ? (
                                        <tr style={{ borderBottom: 'hidden' }}>
                                            <th scope="row">Amount</th>
                                            <td>{payment?.account?.currency?.prefix} {AmountDivideByHundred(paymentInfo?.amount)}</td>
                                        </tr>
                                    ) : (
                                        <></>
                                    )
                                }
                                {
                                    paymentInfo?.coupleDiscountAmount ? (
                                        <tr style={{ borderBottom: 'hidden' }}>
                                            <th scope="row">Couple Discount</th>
                                            <td>{payment?.account?.currency?.prefix} ({AmountDivideByHundred(paymentInfo?.coupleDiscountAmount)})</td>
                                        </tr>
                                    ) : (
                                        <></>
                                    )
                                }
                                {
                                    paymentInfo?.deliveryFee ? (
                                        <tr style={{ borderBottom: 'hidden' }}>
                                            <th scope="row">Delivery Fee</th>
                                            <td>{payment?.account?.currency?.prefix} {AmountDivideByHundred(paymentInfo?.deliveryFee)}</td>
                                        </tr>
                                    ) : (
                                        <></>
                                    )
                                }
                                {
                                    paymentInfo?.discountedAmount ? (
                                        <tr style={{ borderBottom: 'hidden' }}>
                                            <th scope="row">Discount</th>
                                            <td>{payment?.account?.currency?.prefix} ({AmountDivideByHundred(paymentInfo?.discountedAmount)})</td>
                                        </tr>
                                    ) : (
                                        <></>
                                    )
                                }
                                {
                                    paymentInfo?.itemDiscount ? (
                                        <tr style={{ borderBottom: 'hidden' }}>
                                            <th scope="row">Item Discount</th>
                                            <td>{payment?.account?.currency?.prefix} ({AmountDivideByHundred(paymentInfo?.itemDiscount)})</td>
                                        </tr>
                                    ) : (
                                        <></>
                                    )
                                }
                                {
                                    paymentInfo?.net ? (
                                        <tr style={{ borderBottom: 'hidden' }}>
                                            <th scope="row">Net</th>
                                            <td>{payment?.account?.currency?.prefix} {AmountDivideByHundred(paymentInfo?.net)}</td>
                                        </tr>
                                    ) : (
                                        <></>
                                    )
                                }
                                {
                                    paymentInfo?.orderDiscount ? (
                                        <tr style={{ borderBottom: 'hidden' }}>
                                            <th scope="row">Order Discount</th>
                                            <td>{payment?.account?.currency?.prefix} ({AmountDivideByHundred(paymentInfo?.orderDiscount)})</td>
                                        </tr>
                                    ) : (
                                        <></>
                                    )
                                }
                                {
                                    paymentInfo?.serviceFee ? (
                                        <tr style={{ borderBottom: 'hidden' }}>
                                            <th scope="row">Service Fee</th>
                                            <td>{payment?.account?.currency?.prefix} {AmountDivideByHundred(paymentInfo?.serviceFee)}</td>
                                        </tr>
                                    ) : (
                                        <></>
                                    )
                                }
                                {
                                    paymentInfo?.serviceFeePercentage ? (
                                        <tr style={{ borderBottom: 'hidden' }}>
                                            <th scope="row">Service %</th>
                                            <td>% {AmountDivideByHundred(paymentInfo?.serviceFeePercentage)}</td>
                                        </tr>
                                    ) : (
                                        <></>
                                    )
                                }
                                {
                                    paymentInfo?.subTotal ? (
                                        <tr style={{ borderBottom: 'hidden' }}>
                                            <th scope="row">Sub Total</th>
                                            <td>{payment?.account?.currency?.prefix} {AmountDivideByHundred(paymentInfo?.subTotal)}</td>
                                        </tr>
                                    ) : (
                                        <></>
                                    )
                                }
                                {
                                    paymentInfo?.subTotalAfterDiscount ? (
                                        <tr style={{ borderBottom: 'hidden' }}>
                                            <th scope="row">Sub Total After Discount</th>
                                            <td>{payment?.account?.currency?.prefix} {AmountDivideByHundred(paymentInfo?.subTotalAfterDiscount)}</td>
                                        </tr>
                                    ) : (
                                        <></>
                                    )
                                }
                                {
                                    paymentInfo?.surcharge ? (
                                        <tr style={{ borderBottom: 'hidden' }}>
                                            <th scope="row">Surcharge</th>
                                            <td>{payment?.account?.currency?.prefix} {AmountDivideByHundred(paymentInfo?.surcharge)}</td>
                                        </tr>
                                    ) : (
                                        <></>
                                    )
                                }
                                {
                                    paymentInfo?.tax ? (
                                        <tr style={{ borderBottom: 'hidden' }}>
                                            <th scope="row">Tax</th>
                                            <td>{payment?.account?.currency?.prefix} {AmountDivideByHundred(paymentInfo?.tax)}</td>
                                        </tr>
                                    ) : (
                                        <></>
                                    )
                                }
                                {
                                    paymentInfo?.tip ? (
                                        <tr style={{ borderBottom: 'hidden' }}>
                                            <th scope="row">Tip</th>
                                            <td>{payment?.account?.currency?.prefix} {AmountDivideByHundred(paymentInfo?.tip)}</td>
                                        </tr>
                                    ) : (
                                        <></>
                                    )
                                }
                                {
                                    paymentInfo?.totalPayable ? (
                                        <tr style={{ background: '#F7F7F7' }}>
                                            <th scope="row">Total Payable</th>
                                            <td class="font-weight-bold">{payment?.account?.currency?.prefix} {AmountDivideByHundred(paymentInfo?.totalPayable)}</td>
                                        </tr>
                                    ) : (
                                        <></>
                                    )
                                }
                                
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="px-4 mt-3">
                    {
                        paymentInfo?.surcharge ? (
                            <div style={{ fontSize: "12px", color: "gray" }}>
                                * {payment?.account?.currency?.prefix} {AmountDivideByHundred(paymentInfo?.surcharge)} fee applied (typically for credit cards)
                            </div>
                        ) : null
                    }
                </div>
                <SubmitButton type="secondary"
                    borderRadius="50px"
                    border="1px solid #40a9ff !important"
                    className="px-3 py-2 mt-3"
                    onClick={() => performApplePayPayment('USD', items, payment.account && payment.account.name ? payment.account.name : accountName, payableAmount)}

                >Pay By Apple Pay {currencyformatter(payableAmount, 'USD')}</SubmitButton>
            </>
        )
    }
};


export default Apple;
